<template>
	<div class="per_right">
		<div class="per_right_1 clearfix">
			<img src="@/images/center_title.png" class="per_right_1back"/>
			<img src="@/images/center_text6.png" class="per_right_1name"/>
		</div>
		<div class="per_right_2">
			<div class="news_right_top" style="font-size: 14px; color:#606266;" v-if="activeModel == 'first'">
				关键词：
				<el-input placeholder="请输入问题关键词" v-model="title" class="news_input" clearable>
				</el-input>
				<img src="@/images/button-query.png" style="position: relative;top: 14px; cursor: pointer;" @click="getTeacherList" />
			</div>
			<div class="news_right_con">
				<el-tabs type="border-card" v-model="activeModel">
					<el-tab-pane label="教师反馈" name='first'>
						<div class="noinfo" v-if='teacherList.length<=0'>暂无教师反馈</div>
						<div class="news_p clearfix" v-for="(item,index) in teacherList">
							<div class="news_head">
								<img :src="baseurl + item.iconFile" v-if="item.iconFile" />
								<img src="@/images/stu.png" v-else/>
							</div>
							<div class="news_words">
								<p class="news_p_name">{{item.createname}}
									<span style="color: #F89B47;">回复</span>
									<span style="font-size: 10px; float: right;">{{item.createtime}}</span>
								</p>
								<p class="news_p_speak">{{item.value}}</p>
								<p class="news_p_comment"><span style="color: #CCCCCC;">我的问题：</span>{{item.question}}</p>
							</div>
						</div>
						<div class="content-coursefoot" style="text-align:center">
							<el-pagination background @current-change="teacherChange" :current-page="teacherPage" :page-size="limit" layout="  prev, pager, next" :total="teachertotal">
							</el-pagination>
						</div>
					</el-tab-pane>
					<el-tab-pane label="课程交流" name='second'>
						<div class="noinfo" v-if='commontList.length<=0'>暂无课程交流</div>
						<div class="news_p clearfix" v-for="(item,index) in commontList">
							<div class="news_head">
								<img :src="baseurl + item.iconFile" v-if="item.iconFile" />
								<img src="@/images/stu.png" v-else/>
							</div>
							<div class="news_words">
								<p class="news_p_name">我
									<span style="color: #F89B47;">评论</span>
									<span style="font-size: 10px; float: right;">{{item.createTime | formatTime}}</span>
								</p>
								<p class="news_p_speak">{{item.content}}</p>
								<p class="news_p_comment"><span style="color: #CCCCCC;">所属课程：</span>{{item.courseName}}-{{item.sectionName}}</p>
							</div>
						</div>
						<div class="content-coursefoot" style="text-align:center">
							<el-pagination background @current-change="commentChange" :current-page="commontPage" :page-size="limit" layout="  prev, pager, next" :total="commonttotal">
							</el-pagination>
						</div>
					</el-tab-pane>
					<el-tab-pane label="公告反馈" name='third'>
						<div class="noinfo" v-if='noticeBackList.length<=0'>暂无公告反馈</div>
						<div class="news_p clearfix" :key="item.id" v-for="item in noticeBackList">
							<div class="news_head">
								<img :src="baseurl + item.iconFile" v-if="item.iconFile" />
								<img src="@/images/stu.png" v-else/>
							</div>
							<div class="news_words">
								<p class="news_p_name">{{item.replyName}}
									<span style="color: #EC272F" v-if="item.state=='0'">等待回复</span>
									<span style="color: #F89B47;" v-if="item.state=='1'">回复</span>
									<span style="font-size: 10px; float: right;">{{item.replyTime}}</span>
								</p>
								<p class="news_p_speak">{{item.replyContext}}</p>
								<p class="news_p_comment"><span style="color: #CCCCCC;">我的反馈：</span>{{item.backContext}}</p>
							</div>
						</div>
						<div class="content-coursefoot" style="text-align:center">
							<el-pagination background @current-change="handleCurrentChange" :current-page="current" :page-size="limit" layout="  prev, pager, next" :total="total">
							</el-pagination>
						</div>
					</el-tab-pane>
				</el-tabs>
			</div>
		</div>
	</div>
</template>

<script>
	import { studentBackList } from '@/api/notice.js'
	import { mycommentList } from '@/api/comment.js'
	import { getMyQuestion } from '@/api/client.js'
	export default {
		data() {
			return {
				noticeBackList: [],
				limit: 10,
				current: 1,
				total: 0,
				title: '',
				activeModel: 'first',

				//教师反馈讨论
				teacherPage: 1,
				teachertotal: 0,
				teacherList: [],

				//课程讨论
				commontPage: 1,
				commonttotal: 0,
				commontList: [],

			}
		},
		created() {
			this.getCommentList();
			this.getTeacherList();
			this.getNoticeBack();
		},
		methods: {
			teacherChange(page) {
				this.teacherPage = page;
				this.getTeacherList()
			},
			getTeacherList() {
				var data = {
					size: this.limit,
					current: this.teacherPage,
					title: this.title ? this.title : null,
				}
				getMyQuestion(data).then(res => {
					if(res.code == "OK") {
						const {
							data
						} = res;
						this.teacherList = res.data.records;
						this.teachertotal = res.data.total;
					}
				})
			},
			commentChange(page) {
				this.commontPage = page;
				this.getCommentList()
			},
			getCommentList() {
				var data = {
					pageSize: this.limit,
					page: this.commontPage,
				}
				mycommentList(data).then(res => {
					if(res.code == 0) {
						const {
							data
						} = res;
						this.commontList = res.data.listData;
						this.commonttotal = res.data.totalRow;
					}
				})
			},
			handleCurrentChange(page) {
				this.current = page;
				this.getNoticeBack()
			},
			getNoticeBack() {
				studentBackList({
					current: this.current,
					limit: this.limit,
				}).then(res => {
					this.noticeBackList = res.data.records
					this.total = res.data.total;
				})
			}
		}
	}
</script>

<style>

</style>